import Grid from "../Grid/Grid";

function Modal({ id, visible, setVisible, title, onSave, children }) {
  const handleCancel = () => {
    setVisible(false);
    const form = document.getElementById(id);
    form.reset();
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const form = event.target;
    const formData = {};

    const inputs = form.querySelectorAll("input, select, textarea");

    inputs.forEach((input) => {
      const id = input.id || input.name;
      if (id) {
        formData[id] = input.value;
      }
    });

    if (onSave) {
      onSave(formData);
    }

    handleCancel();
  };

  return (
    <form onSubmit={handleSubmit} id={id}>
      <div
        className={`modal fade ${visible ? "show" : ""}`}
        id={id}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden={!visible}
        data-keyboard
        data-backdrop={visible}
        style={{ display: visible ? "block" : "none" }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content search-modal">
            <Grid>
              <h3 className="text-dark modal-header col-12">{title}</h3>
              {children}
            </Grid>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-toggle="modal"
                data-target={`#${id}`}
                onClick={() => handleCancel()}
              >
                Abbrechen
              </button>
              <button
                type="submit"
                className="btn btn-primary btn-search-custom dismiss-active-or-focus"
                data-toggle="modal"
                data-target={`#${id}`}
              >
                Hinzufügen
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

export default Modal;
